import { InjectionToken } from "@angular/core";

export const AUDIO_CHANNEL_PRESETS = new InjectionToken("AUDIO_CHANNEL_PRESETS");

export const audioChannelPresetData = [
    {
        name: "TBD",
        abbreviation: "TBD",
        positions: ["TBD"],
        isVisible: false,
    },
    {
        name: "Mono",
        abbreviation: "Mono",
        positions: ["Mono"],
        isVisible: true,
    },
    {
        name: "2.0 Stereo",
        abbreviation: "2.0",
        positions: [
            "2.0 LT",
            "2.0 RT",
        ],
        isVisible: true,
    },
    {
        name: "2.0 LoRo",
        abbreviation: "2.0 LoRo",
        positions: [
            "2.0 Lo",
            "2.0 Ro",
        ],
        isVisible: true,
    },
    {
        name: "2.0 LoRo Deprecated",
        abbreviation: "2.0 LoRo",
        positions: [
            "2.0 LoRo LT",
            "2.0 LoRo RT",
        ],
        isVisible: false ,
    },
    {
        name: "5.1 Surround",
        abbreviation: "5.1",
        positions: [
            "5.1 Left",
            "5.1 Right",
            "5.1 Center",
            "5.1 Subwoofer",
            "5.1 Left Surround",
            "5.1 Right Surround",
        ],
        isVisible: true,
    },
    {
        name: "7.1 Surround",
        abbreviation: "7.1",
        positions: [
            "7.1 Left",
            "7.1 Right",
            "7.1 Center",
            "7.1 Subwoofer",
            "7.1 Left Surround",
            "7.1 Right Surround",
            "7.1 Left Surround Rear",
            "7.1 Right Surround Rear",
        ],
        isVisible: true,
    },
    {
        name: "Mono AD",
        abbreviation: "Mono AD",
        positions: ["Mono AD"],
        isVisible: true,
    },
    {
        name: "2.0 AD",
        abbreviation: "2.0 AD",
        positions: [
            "2.0 AD LT",
            "2.0 AD RT",
        ],
        isVisible: true,
    },
    {
        name: "Mono Split Track",
        abbreviation: "Split Mono",
        positions: [
            "Mono Dialog",
            "Mono Music",
            "Mono Effects",
        ],
        isVisible: false,
    },
    {
        name: "2.0 Split Track",
        abbreviation: "2.0 Split",
        positions: [
            "Dialog Left",
            "Dialog Right",
            "Music Left",
            "Music Right",
            "Effects Left",
            "Effects Right",
        ],
        isVisible: false,
    },
    {
        name: "5.1 Split Track",
        abbreviation: "5.1 Split",
        positions: [
            "Dialog Left",
            "Dialog Right",
            "Dialog Center",
            "Dialog LFE",
            "Dialog Left Surround",
            "Dialog Right Surround",
            "Music Left",
            "Music Right",
            "Music Center",
            "Music LFE",
            "Music Left Surround",
            "Music Right Surround",
            "Effects Left",
            "Effects Right",
            "Effects Center",
            "Effects LFE",
            "Effects Left Surround",
            "Effects Right Surround",
        ],
        isVisible: false,
    },
    {
        name: "7.1 Split Track",
        abbreviation: "7.1 Split",
        positions: [
            "Dialog Left",
            "Dialog Right",
            "Dialog Center",
            "Dialog Subwoofer",
            "Dialog Left Surround",
            "Dialog Right Surround",
            "Dialog Left Surround Rear",
            "Dialog Right Surround Rear",
            "Music Left",
            "Music Right",
            "Music Center",
            "Music Subwoofer",
            "Music Left Surround",
            "Music Right Surround",
            "Music Left Surround Rear",
            "Music Right Surround Rear",
            "Effects Left",
            "Effects Right",
            "Effects Center",
            "Effects Subwoofer",
            "Effects Left Surround",
            "Effects Right Surround",
            "Effects Left Surround Rear",
            "Effects Right Surround Rear",
        ],
        isVisible: false,
    },
    {
        name: "Mono M&E",
        abbreviation: "M&E Mono",
        positions: ["Mono M&E"],
        isVisible: true,
    },
    {
        name: "2.0 M&E",
        abbreviation: "2.0 M&E",
        positions: [
            "2.0 M&E LT",
            "2.0 M&E RT",
        ],
        isVisible: true,
    },
    {
        name: "5.1 M&E",
        abbreviation: "5.1 M&E",
        positions: [
            "5.1 M&E Left",
            "5.1 M&E Right",
            "5.1 M&E Center",
            "5.1 M&E Subwoofer",
            "5.1 M&E Left Surround",
            "5.1 M&E Right Surround",
        ],
        isVisible: true,
    },
    {
        name: "7.1 M&E",
        abbreviation: "7.1 M&E",
        positions: [
            "7.1 M&E Left",
            "7.1 M&E Right",
            "7.1 M&E Center",
            "7.1 M&E Subwoofer",
            "7.1 M&E Left Surround",
            "7.1 M&E Right Surround",
            "7.1 M&E Left Surround Rear",
            "7.1 M&E Right Surround Rear",
        ],
        isVisible: true,
    },
    {
        name: "7.1 + 4 (Atmos)",
        abbreviation: "7.1+4 Atmos",
        positions: [
            "7.1+4 (Atmos) Left",
            "7.1+4 (Atmos) Right",
            "7.1+4 (Atmos) Center",
            "7.1+4 (Atmos) Subwoofer",
            "7.1+4 (Atmos) Left Surround",
            "7.1+4 (Atmos) Right Surround",
            "7.1+4 (Atmos) Left Surround Rear",
            "7.1+4 (Atmos) Right Surround Rear",
        ],
        isVisible: true,
    },
    {
        name: "MOS",
        abbreviation: "MOS",
        positions: ["MOS"],
        isVisible: true,
    },
    {
        name: "2.0 Optional",
        abbreviation: "2.0 Opt",
        positions: ["2.0 Optional"],
        isVisible: false,
    },
    {
        name: "4.0 LCRS",
        abbreviation: "4.0",
        positions: [
            "4.0 Left",
            "4.0 Right",
            "4.0 Center",
            "4.0 Surround"
        ],
        isVisible: false,
    }
];

export const audioChannelPresetProvider = {
    provide: AUDIO_CHANNEL_PRESETS,
    useValue: audioChannelPresetData,
};
